@let dep = property();

<div
  class="ui-property-summary-card"
  [class.ui-property-summary-card--overdue]="isOverdue()"
  [class.ui-property-summary-card--paid]="isPaid()"
>
  <div class="ui-property-summary-card__preview" (click)="onPreviewClick($event)">
  <div class="ui-property-summary-card__image-wrap">
    <img class="ui-property-summary-card__image" [src]="dep.image" alt="Departamento" />
  </div>
  <div class="ui-property-summary-card__details">
    <h3 class="ui-property-summary-card__development">{{ dep.development }}</h3>
    <dl class="ui-property-summary-card__meta">
      <div class="ui-property-summary-card__meta-row">
        <dt>Modelo</dt>
        <dd>{{ dep.model }}</dd>
      </div>
      <div class="ui-property-summary-card__meta-row">
        <dt>Unidad</dt>
        <dd>{{ dep.unit }}</dd>
      </div>
    </dl>
    <ul class="ui-property-summary-card__features" role="list">
      @for (feat of dep.features; track feat.label) {
        <li class="ui-property-summary-card__feature">
          <span
            class="ui-property-summary-card__feature-icon"
            [style.mask-image]="'url(' + feat.iconSrc + ')'"
            [style.webkitMaskImage]="'url(' + feat.iconSrc + ')'"
            aria-hidden="true"
          ></span>
          <span>{{ feat.label }}</span>
        </li>
      }
    </ul>
    <ui-button
      variant="primary"
      size="sm"
      (pressed)="viewDepartmentClick.emit()"
    >
      {{ viewDepartmentLabel() }}
    </ui-button>
  </div>
  </div>
  <div class="ui-property-summary-card__account-wrap">
    <dl class="ui-property-summary-card__account">
      <div class="ui-property-summary-card__account-balance">
        <div class="ui-property-summary-card__account-balance-copy">
          <dt>Saldo</dt>
          <dd>{{ displayBalance() }}</dd>
        </div>
        <ui-button variant="secondary" size="sm" (pressed)="statementClick.emit()">
          {{ statementLabel() }}
        </ui-button>
      </div>
      @if (isOverdue()) {
        <div class="ui-property-summary-card__overdue">
          <ui-tag label="Atrasado" color="danger" />
          <ui-tag [label]="overduePaymentsLabel()" color="warning" />
          <p class="ui-property-summary-card__overdue-amount">
            {{ overdueAmount() }}
          </p>
        </div>
      }
      @if (isPaid()) {
        <div class="ui-property-summary-card__overdue">
          <ui-tag
            class="ui-property-summary-card__paid-tag"
            label="Pagado"
            color="success"
          />
        </div>
      }
      <div class="ui-property-summary-card__account-payments">
        @if (!isPaid()) {
          <div class="ui-property-summary-card__account-row">
            <dt>Próximo pago</dt>
            <dd>
              <strong>{{ dep.nextPaymentAmount }}</strong>
              <span>{{ dep.nextPaymentDate }}</span>
            </dd>
            <ui-button variant="ghost" size="sm" (pressed)="registerPaymentClick.emit()">
              {{ registerPaymentLabel() }}
            </ui-button>
          </div>
        }
        <div class="ui-property-summary-card__account-row">
          <dt>Último pago</dt>
          <dd>
            <strong>{{ dep.lastPaymentAmount }}</strong>
            <span>{{ dep.lastPaymentDate }}</span>
          </dd>
          <ui-button
            class="ui-property-summary-card__receipt-button"
            variant="ghost"
            size="sm"
            (pressed)="downloadReceiptClick.emit()"
          >
            {{ downloadReceiptLabel() }}
          </ui-button>
        </div>
      </div>
    </dl>
  </div>
  <div class="ui-property-summary-card__progress">
    <div class="ui-property-summary-card__carousel">
      @if (canPrevProgress()) {
        <button
          type="button"
          class="ui-property-summary-card__carousel-nav ui-property-summary-card__carousel-nav--prev"
          aria-label="Videos anteriores"
          (click)="shiftProgress(-1)"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path
              d="M14.5 6.5 9 12l5.5 5.5"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      }
      <div
        class="ui-property-summary-card__carousel-viewport"
        (pointerdown)="onProgressSwipeStart($event)"
        (pointerup)="onProgressSwipeEnd($event)"
      >
        <div
          class="ui-property-summary-card__carousel-track"
          [style.--progress-shift]="progressIndex()"
        >
          @for (clip of dep.progressClips; track clip.title) {
            <article class="ui-property-summary-card__clip">
              <h5 class="ui-property-summary-card__clip-title">{{ clip.title }}</h5>
              <div class="ui-property-summary-card__clip-media">
                <video
                  class="ui-property-summary-card__clip-thumb"
                  [src]="clip.src"
                  muted
                  preload="metadata"
                  playsinline
                  (loadedmetadata)="onProgressThumbReady($event)"
                ></video>
                <button
                  type="button"
                  class="ui-property-summary-card__clip-play"
                  [attr.aria-label]="'Reproducir ' + clip.title"
                  (click)="openProgressVideo(clip)"
                >
                  <svg
                    class="ui-property-summary-card__clip-play-icon"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <path d="M9.75 7.2v9.6L17.7 12 9.75 7.2z" fill="currentColor" />
                  </svg>
                </button>
              </div>
            </article>
          }
        </div>
      </div>
      @if (canNextProgress()) {
        <button
          type="button"
          class="ui-property-summary-card__carousel-nav ui-property-summary-card__carousel-nav--next"
          aria-label="Videos siguientes"
          (click)="shiftProgress(1)"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path
              d="M9.5 6.5 15 12l-5.5 5.5"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      }
    </div>
  </div>
</div>
